module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "CHAP-TITLE"
  }, [_vm._v("Spread the Red")]), _vm._v(" "), _c('p', {
    staticClass: "BOD2"
  }, [_vm._v("Attach a bright red motif to a child’s cardigan, a hat, a bag, the sleeve of your jumper or hem of a skirt – where will you put yours?")]), _vm._v(" "), _c('p', {
    staticClass: "IMAGE"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "IMAGE"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-6.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6673103e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter1-3.vue
// module id = 72
// module chunks = 0